import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useDataset from "datasets/hooks/useDataset";
import usePermissions from "datasets/hooks/usePermissions";
import { removeDashboard } from "datasets/pages/dashboards/api/dashboardApi";
import useDatasetDashboards from "datasets/pages/dashboards/hooks/useDatasetDashboards";
import useReport from "datasets/pages/dashboards/hooks/useReport";
import queryString from "query-string";
import yn from "yn";
import Loading from "~/components/Loading";
import SigmaEmbed from "~/components/SigmaEmbed";
import useErrorToast from "~/contexts/error-toast";
import rumClient, { trackEvent } from "~/utils/monitoring";

const DatasetReport = () => {
  const { datasetId, reportId } = useParams();
  const { data: report } = useReport();
  const { mutate: mutateDataset } = useDataset();
  const { mutate: mutateDashboards } = useDatasetDashboards();
  const { showError } = useErrorToast();
  const navigate = useNavigate();
  const hasEditPermission = usePermissions("edit:catalog-report");

  const handleClose = () => navigate("..", { relative: "path" });

  const handleRemove = async () => {
    try {
      await removeDashboard(datasetId!, reportId!);
      await mutateDataset();
      await mutateDashboards();
      handleClose();
    } catch (e: any) {
      console.error(e);
      rumClient?.recordError(e);
      showError(e.message);
    }
  };

  const messageHandler = async (e: MessageEvent) => {
    if ("workbook:ondelete" === e.data.type) {
      await handleRemove();
    }
  };

  useEffect(() => {
    trackEvent("dataset_dashboard_viewed", {
      dataset_id: datasetId,
      dashboard_id: reportId,
    });
  }, [datasetId, reportId]);

  if (!report) {
    return <Loading />;
  }

  return (
    <SigmaEmbed
      title={report.displayName}
      datasetId={datasetId}
      dashboardId={report.id}
      messageHandler={messageHandler}
      onClose={handleClose}
      allowEdits={hasEditPermission}
    />
  );
};

export default DatasetReport;
